
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
import { partsQuantityRules } from "@common/src/utils/verify";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const common_base = namespace("common_base");
@InjectFunction("permit", "emptyToLine", "splitThousands", "addCurrencyUnit")
@Component({ components: { MyCheckbox } })
export default class InWareHouseEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @inventory.Action getInWarehouseDetail;
  @inventory.Action inWarehouseComplete;
  @user.State userData;
  @base.Action getDictionaryList;
  @inventory.Action saveInWarehouse;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  @inventory.Action queryPartsQtyByWarehouseTree;
  get breadData() {
    return [
      { name: t("warehouse.inbound-manage"), path: "/inventory/in-warehouse" },
      { name: this.isAdd ? t("warehouse.add-inbound-order") : t("warehouse.edit-inbound-order") }
    ];
  }
  get isAdd() {
    return this.$route.name === "inWarehouseAdd";
  }
  orderFormDataRules = {
    inboundType: [{ required: true, message: t("warehouse.please-inbound-type"), trigger: "change" }]
  };
  advisorList: any[] = [{}];
  orderFormData: any = {
    inboundType: "",
    inboundUser: "",
    remark: "",
    detailList: [],
    costAmount: "0"
  };
  get isEditUnitPrice() {
    return this.orderFormData.inboundType === "1" || this.orderFormData.inboundType === "4";
  }
  definitionPartsData: any = {
    partsInfo: {},
    costAmount: "",
    qty: "",
    totalInventory: 0,
    costPrice: "",
    partsCode: "",
    warehouseCode: "",
    shelfCode: "",
    remark: "",
    list: [],
    shelfList: []
  };
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(100);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  inWarehouseTypeList: any = [];
  async init() {
    // 不显示采购和退料类型
    this.getDictionaryList("inbound_type").then(data => {
      this.inWarehouseTypeList = data.filter(item => item.dataValue !== "3" && item.dataValue !== "1");
    });
    this.getPartsLists();
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.getInWarehouseDetail({
        inboundNo: this.orderId
      }).then(data => {
        this.orderFormData = data.data;
        data.data.detailList.forEach((item, index) => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push(item);
          }
          this.handleChooseParts(item.partsCode, index, item, "init");
        });
      });
    } else {
      this.orderFormData.inboundUser = this.userData.userCode;
    }
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
    });
  }
  computedAmount(index) {
    let costAmount = (this.orderFormData.detailList[index].qty || 0) * this.orderFormData.detailList[index].costPrice;
    this.orderFormData.detailList[index].costAmount = costAmount.toFixed(2);
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.detailList.reduce((preV, curV) => {
      console.log(4441, preV, curV);
      return preV + Number(curV.costAmount);
    }, 0);
    console.log(666, partsTotal);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("other.amount-quantity-number-tips"));
    }
    this.orderFormData.costAmount = partsTotal.toFixed(2);
  }
  searchParts(val) {
    this.getPartsLists(val);
  }

  emitComplete(orderId?) {
    let inboundNo = orderId || this.orderId;
    this.inWarehouseComplete({
      inboundNo: inboundNo
    })
      .then(() => {
        this.$message.success(t("warehouse.inbound-success") as string);
        this.$router.push(`/inventory/in-warehouse-view/${inboundNo}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleChooseParts(val, index, row, type = "manual") {
    this.queryPartsQtyByWarehouseTree({
      partsCode: val
    }).then(data => {
      const warehouseList = this.$safeValue(data, "data.warehouseList", []);
      const defaultWarehouse = warehouseList.find(item => item.defaultWarehouse === 1);
      const partsInfo = warehouseList[0];
      let partsData = Object.assign({}, row, {
        partsCode: val,
        partsInfo: partsInfo,
        list: warehouseList,
        totalInventory: data.data.inventoryQty
      });
      if (type === "manual") {
        partsData.qty = "";
        partsData.costAmount = "";
        partsData.warehouseCode = "";
        partsData.shelfCode = "";
        partsData.costPrice =
          this.orderFormData.inboundType === "2" ? partsInfo.costPrice || "" : partsInfo.purchasePrice || "0";
        if (defaultWarehouse) {
          partsData.warehouseCode = defaultWarehouse.warehouseCode;
          this.handleWarehouseChange(partsData, type);
        }
      } else {
        this.handleWarehouseChange(partsData, type);
        partsData.costPrice = row.costPrice || "";
        partsData.costAmount = row.costAmount || "";
      }
      this.orderFormData.detailList.splice(index, 1, partsData);
      this.computedAmount(index);
    });
  }

  checkAddData(): boolean {
    if (!this.orderFormData.inboundType) {
      this.$message.error(t("warehouse.please-inbound-type") as string);
      return false;
    }
    if (this.orderFormData.detailList.length < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.detailList.length; index++) {
      const element = this.orderFormData.detailList[index];
      if (!element.partsCode) {
        this.$message.error(t("v210801.pls-select-inbound-parts"));
        return false;
      }
      if (!element.qty) {
        this.$message.error(t("v210801.pls-input-inbound-num"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (this.orderFormData.inboundType === "4" && !element.costPrice) {
        this.$message.error(t("v210801.pls-input-cost-unit"));
        return false;
      }
      if (!element.warehouseCode || !element.shelfCode) {
        this.$message.error(t("v210.please-select-the-warehousing-warehouse-location"));
        return false;
      }
    }
    return true;
  }
  operationName: string = "";
  handleComplete() {
    this.operationName = "complete";
    this.emitSaveInWarehouse();
  }
  handleSaveInWarehouse() {
    this.operationName = "save";
    this.emitSaveInWarehouse();
  }
  emitSaveInWarehouse() {
    (this.$refs["inWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        this.saveInWarehouse(this.orderFormData)
          .then(data => {
            if (this.operationName === "save") {
              this.$message.success(t("base.save-success") as string);
              this.$router.push(`/inventory/in-warehouse-view/${data.data.inboundNo}`);
            } else {
              this.emitComplete(data.data.inboundNo);
            }
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleInTypeChange(val) {
    if (val === "2") {
      this.orderFormData.detailList.forEach(item => {
        item.costPrice = item.list[0] ? item.list[0].costPrice : "";
      });
    }
  }
  handleAddParts() {
    this.orderFormData.detailList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  warehousePartsMap: any = {};
  handleWarehouseChange(row, type = "manual") {
    let seletedWarehouse = row.list.find(item => row.warehouseCode === item.warehouseCode);
    row.shelfList = seletedWarehouse && seletedWarehouse.shelfList;
    const defaultShelf = row.shelfList.find(item => item.defaultShelf === 1);
    if (type === "manual") {
      if (defaultShelf) {
        row.shelfCode = defaultShelf.shelfCode;
      } else {
        row.shelfCode = "";
      }
    }
  }
  handleShelfSelectFocus(row) {
    if (!row.warehouseCode) {
      this.$message.error(t("v210.please-select-the-spare-parts-and-warehouse-first"));
    }
  }
  showInConfirmTips: boolean = false;
  handleShowInConfrimTips() {
    (this.$refs["inWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.showInConfirmTips = true;
      }
    });
  }
}
